import { render, staticRenderFns } from "./GBHeaderCalendar.vue?vue&type=template&id=2e6b561d&"
import script from "./GBHeaderCalendar.vue?vue&type=script&lang=js&"
export * from "./GBHeaderCalendar.vue?vue&type=script&lang=js&"
import style0 from "./GBHeaderCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports